import React, { Component } from 'react'
import { Button, TableRow, TableCell } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'

import {
  EditableTextField,
  EditableSwitch,
  EditableReactSelect,
} from '../common/EditableComponents'

export default class ShopTerminalItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  convertArrayToOptions = (array) => {
    return array.map((region) => {
      return { label: region.name, value: region.id }
    })
  }

  onChangeRegions = (regions) => {
    const regionIds =
      (regions &&
        regions.map((region) => {
          return region.value
        })) ||
      []
    this.props.onChange('regions', regionIds)
  }

  render() {
    const { data, editMode, regions } = this.props

    const regionOptions = this.convertArrayToOptions(regions.filter((region) => region.active))

    const selectedRegions =
      (regions &&
        regions.filter((region) => {
          return data.regionIds.find((regionId) => region.active && region.id === regionId)
        })) ||
      []

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.name}
            editMode={editMode}
            value={data.name}
            onChange={this.onChange('name')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell style={{ minWidth: editMode ? 200 : 50 }} className="cell-wrap-word">
          <EditableReactSelect
            multi={true}
            valueToRender={selectedRegions.map((region) => region.name).join(', ')}
            editMode={editMode}
            value={this.convertArrayToOptions(selectedRegions)}
            onChange={this.onChangeRegions}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
            options={regionOptions}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.active ? 'Active' : 'Inactive'}
            checked={data.active}
            editMode={editMode}
            onChange={this.onChange('active', true)}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <Button className="primary-button margin" onClick={this.props.onEdit}>
            View
          </Button>
          {!editMode ? (
            <Button className="danger-button margin" onClick={this.props.onDelete}>
              Delete
            </Button>
          ) : null}
        </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DeliveryTax/DeliveryTaxItem.js